import { proNavigator } from "single-spa/react-app/ProNavigator";
import { BasicDurations } from "app/services/DurationService";

const { LAST_MONTH, LAST_THREE_MONTHS, LAST_SIX_MONTHS } = BasicDurations;

export const resolveOverrideDatePickerPresetWebsiteAnalysis = (): string[] | null => {
    const params = proNavigator.getParams();
    return params.comparedDuration ? [LAST_MONTH, LAST_THREE_MONTHS, LAST_SIX_MONTHS] : null;
};
